import { render, staticRenderFns } from "./AdminMfaPolicySettings.vue?vue&type=template&id=8cc6541c&scoped=true&"
import script from "./AdminMfaPolicySettings.vue?vue&type=script&lang=js&"
export * from "./AdminMfaPolicySettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminMfaPolicySettings.vue?vue&type=style&index=0&id=8cc6541c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc6541c",
  null
  
)

export default component.exports